export const url = "https://zscaler-automation-worker.rheintec.ch";
//export const url = "http://localhost:8787";

export function objectToOperationString(obj, indent = 0) {
    let result = '';

    for (const key in obj) {
        const value = obj[key];

        if (typeof value === 'object' && !Array.isArray(value)) {
            result += `${' '.repeat(indent)}${key}:\n${objectToOperationString(value, indent + 4)}`;
        } else if (Array.isArray(value)) {
            result += `${' '.repeat(indent)}${key}(${obj[key].length}):\n`;
            for (const item of value) {
                result += `${' '.repeat(indent + 4)}- ${item}\n`;
            }
        } else {
            result += `${' '.repeat(indent)}${key} : ${value}\n`;
        }
    }

    return result;
}